<!-- <div *ngIf="!tokenValid; else tokenValidated">

  <div class="ui segment">
    Registration is currently closed.
  </div>

</div> -->


<!-- <ng-template #tokenValidated> -->
<div class="register">

  <div *ngIf="!justRegistered; else registered">

    <div class="section-title centered">Create an Account</div>

    <app-load-error [loadError]="actionError" *ngIf="actionError"></app-load-error>

    <div>

      <div class="ui form">

        <div class="field required">
          <label>Email</label>
          <div class="ui left icon input">
            <i class="user icon"></i>
            <input type="text" name="email" placeholder="E-mail address" [(ngModel)]="newUserInfo.email" />
          </div>
          <div class="ui pointing left red basic label" *ngIf="submitted && newUserInfo.email == null">
            Email is required.
          </div>
        </div>

        <div class="field required">
          <label>Password</label>

          <div class="ui left icon input">
            <i class="lock icon"></i>
            <input type="password" name="password" placeholder="Password" [(ngModel)]="newUserInfo.password"
              (ngModelChange)="checkPasswordRequirements()" />
          </div>

          <div class="password-requirements">

            <div class="header">Password requirements:</div>

            <div class="list">
              <div>
                <i class="icon check" *ngIf="this.passwordRequirements.length"></i>
                <i class="icon arrow alternate circle right" *ngIf="!this.passwordRequirements.length"></i>
                At least 8 characters.
              </div>
              <div>
                <i class="icon check" *ngIf="this.passwordRequirements.uppercase"></i>
                <i class="icon arrow alternate circle right" *ngIf="!this.passwordRequirements.uppercase"></i>
                Contains at least one uppercase letter.</div>
              <div>
                <i class="icon check" *ngIf="this.passwordRequirements.lowercase"></i>
                <i class="icon arrow alternate circle right" *ngIf="!this.passwordRequirements.lowercase"></i>
                Contains at least one lowercase letter.</div>
              <div>
                <i class="icon check" *ngIf="this.passwordRequirements.number"></i>
                <i class="icon arrow alternate circle right" *ngIf="!this.passwordRequirements.number"></i>
                Contains at least one number.</div>
            </div>

          </div>


          <div class="ui pointing left red basic label" *ngIf="submitted && !passwordRequirementsMet">
            Password must meet these requirements.
          </div>

        </div>

        <div class="field required">
          <label>Confirm Password</label>
          <div class="ui left icon input">
            <i class="lock icon"></i>
            <input type="password" name="password" placeholder="Confirm Password" [(ngModel)]="newUserInfo.c_password"
              (ngModelChange)="checkPasswordsMatch()" />
          </div>
          <div class="ui pointing left red basic label" *ngIf="submitted && !enteredFields.passwordsMatch">
            Passwords do not match.
          </div>
        </div>

        <div class="field required">
          <div class="ui checkbox">
            <input type="checkbox" name="terms" [(ngModel)]="newUserInfo.agreed">
            <label>I agree to <a (click)="showDisclaimer()">the Curriculum Links User Agreement</a>.</label>
          </div>
          <div class="ui pointing left red basic label" *ngIf="submitted && !newUserInfo.agreed">
            You must agree to the user agreement.
          </div>

        </div>


        <div class="button-desc">
          Confirmation email will be sent to your email address above after submitting this form.
        </div>

        <button class="ui fluid large primary button" (click)="register()" [ngClass]="{loading: inProgress}">Create an
          Account</button>


        <div class="ui error message"></div>

      </div>

    </div>


  </div>


  <ng-template #registered>


    <h2 class="ui header center aligned light">Almost Done...</h2>

    <div class="after-registration">
      Confirmation email has been sent to your email address. Please click on the link in the email to finish the
      registration process. If you do not receive email please check your spam and junk folders.
    </div>



  </ng-template>


  <div class=" modal-window" [ngClass]="{'show': shouldShowDisclaimer}">


    <div class="modal-window-content disclaimer">
      <i class="close icon" (click)="closeDisclaimer()"></i>
      <div *ngIf="appInfo" [innerHTML]="appInfo.terms"></div>
    </div>

  </div>


</div>




<!-- </ng-template> -->
<!--  -->